/**
 * Incremental gift UVP for the cart-wide campaign ladder.
 * Mixer@2, Cup@3 (Mixer drops), Mixer+Cup@4+.
 * Incremental = projected gift UVP − current gift UVP.
 *
 * PPO card labels are keyed by mixer/cup — never product titles.
 * Canonical titles stay in Admin, BOGOS, cart, checkout, and product pages.
 *
 * Classic Shopify asset (globals) + Node CJS export for tests.
 */
const PPO_GIFT_CARD_LABELS = {
  mixer: "Mixer",
  cup: "1,2-L-Drink-Cup",
};

function ppoGiftCardLabel(key, labels, fallbackTitle) {
  const map = labels && typeof labels === "object" ? labels : PPO_GIFT_CARD_LABELS;
  const fromKey = map[key];
  if (typeof fromKey === "string" && fromKey) return fromKey;
  return typeof fallbackTitle === "string" ? fallbackTitle : "";
}

function ppoGiftBenefitLabel(key, labels, gratisWord, fallbackTitle) {
  const name = ppoGiftCardLabel(key, labels, fallbackTitle);
  if (!name) return "";
  const gratis = typeof gratisWord === "string" && gratisWord ? gratisWord : "Gratis";
  return `${gratis} ${name}`;
}

function ppoGiftItemsValueCents(items) {
  return (items || []).reduce((sum, gift) => sum + Number(gift?.price || 0), 0);
}

function ppoIncrementalGiftValueCents(projectedItems, currentItems) {
  return ppoGiftItemsValueCents(projectedItems) - ppoGiftItemsValueCents(currentItems);
}

if (typeof module === "object" && module.exports) {
  module.exports = {
    PPO_GIFT_CARD_LABELS,
    ppoGiftCardLabel,
    ppoGiftBenefitLabel,
    ppoGiftItemsValueCents,
    ppoIncrementalGiftValueCents,
  };
}
